import { render } from "./CreateEditQuestionModal.vue?vue&type=template&id=cfa91996"
import script from "./CreateEditQuestionModal.vue?vue&type=script&lang=js"
export * from "./CreateEditQuestionModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__